
import type { FeatureAccessKey } from "./FeatureAccess.ts";

// Generated from io.spcfy.iv3.authorization.Feature

export type FeatureKey =
  "SPIN" |
  "SPIN_ALGORITHM_CHOICE" |
  "SPIN_LOOKUP" |
  "KRONA" |
  "TRAITS" |
  "OTU_TABLE" |
  "PROJECTS" |
  "SAVED_VIEWS" |
  "CSV_GRID_EDITOR" |
  "ORDER_WIZARD" |
  "COLOR_CODE";


export interface FeatureDTO {
  key: FeatureKey;
  requires?: FeatureAccessKey;
  inheritsFromOrder: boolean;
  frontendOnly: boolean;    
}


export const Features: Record<FeatureKey, FeatureDTO> = {
  SPIN: { key: "SPIN", requires: "TIER2", inheritsFromOrder: true, frontendOnly: false },
  SPIN_ALGORITHM_CHOICE: { key: "SPIN_ALGORITHM_CHOICE", requires: "BETA", inheritsFromOrder: false, frontendOnly: false },
  SPIN_LOOKUP: { key: "SPIN_LOOKUP", inheritsFromOrder: false, frontendOnly: false },
  KRONA: { key: "KRONA", requires: "TIER2", inheritsFromOrder: true, frontendOnly: false },
  TRAITS: { key: "TRAITS", requires: "TIER2", inheritsFromOrder: true, frontendOnly: false },
  OTU_TABLE: { key: "OTU_TABLE", requires: "TIER2", inheritsFromOrder: true, frontendOnly: false },
  PROJECTS: { key: "PROJECTS", requires: "TIER2", inheritsFromOrder: false, frontendOnly: false },
  SAVED_VIEWS: { key: "SAVED_VIEWS", inheritsFromOrder: false, frontendOnly: false },
  CSV_GRID_EDITOR: { key: "CSV_GRID_EDITOR", inheritsFromOrder: false, frontendOnly: true },
  ORDER_WIZARD: { key: "ORDER_WIZARD", inheritsFromOrder: false, frontendOnly: true },
  COLOR_CODE: { key: "COLOR_CODE", requires: "BETA", inheritsFromOrder: false, frontendOnly: true }
};
